// Base URLs
const baseUrl = "/header";
const baseUrlManual = "/qmsSet";
const baseUrlClient = "/client";
const baseUrlNotification = "/notifications";
const baseUrlProcedure = "/procedure";
const baseUrlQualityManual = "/quality-manual";
const baseUrlDocChangeNote = "/docChangeNote";

// Headers
export const CREATE_HEADER = `${baseUrl}/get`;
export const SAVE_HEADER = `${baseUrl}/update`;
export const SAVE_HEADER_WITH_MEDIA = `${baseUrl}/update-with-image`;
export const GET_HEADER = `${baseUrl}/`;
export const GET_THEME = `${baseUrl}/`;
export const GET_NEW_HEADER = `${baseUrl}/get-header`;
export const GET_SPECIFIC_HEADER = `${baseUrl}/get-specific`;
export const SAVE_HEADER_DESIGN = `${baseUrl}/save`;

// Quality Manual (QMSSet)
export const ADD_MANUAL = `${baseUrlManual}/qualityManual`;
export const UPDATE_STATUS = `${baseUrlManual}/qualityManual/update-status`;
export const UPDATE_MANUAL = `${baseUrlManual}/qualityManual/update`;
export const GET_ALL_MANUAL = `/quality-manual/get`;
export const GET_MANUAL_BY_ID = `${baseUrlManual}/qualityManual/get-manual`;
export const MANUAL_LIST = `${baseUrlManual}/qualityManual`;
export const ADD_STANDARD = "/standard/";
export const UPDATE_QM = `${baseUrlManual}/qualityManual/`;
export const GET_MANUAL_BY_DOCID = `${baseUrlManual}/qualityManual/getManualByDocId`;
export const GET_ROLES_AND_RESPONSIBILITY = `${baseUrlQualityManual}/get-roles`;

// Quality Manual (Direct)
export const DOWNLOAD_MANUAL = `${baseUrlQualityManual}/download`;
export const DOWNLOAD_IOP = `${baseUrlQualityManual}/download-iop`;
export const DOWNLOAD_ROLES_RESPONSIBILITY = `${baseUrlQualityManual}/download/roles`;
export const UPDATE_IOP = `${baseUrlQualityManual}/update-iop`;
export const QUALITY_MANUAL_YEAR_LIST = `${baseUrlQualityManual}/by-type/`;

export const GET_BY_ID = `${baseUrlQualityManual}/`;
export const GET_ALL_QUALITY_MANAULS = `${baseUrlQualityManual}/get-qms/`;

// Change Notes
export const CREATE_DOC_CHANGE_NOTE = `${baseUrlDocChangeNote}`;
export const UPDATE_CHANGE_NOTE = `${baseUrlDocChangeNote}/update-specific`;
export const MAKE_VERSION = `${baseUrlDocChangeNote}/make-version`;
export const GET_CHANGE_NOTE_BY_ID = `${baseUrlDocChangeNote}/`;

// Roles and Users
export const GET_ALL_ROLES_API = `${baseUrlClient}/users/designation`;
export const GET_USERS = `${baseUrlClient}/users/`;
export const GET_ALL_CLIENTS_USER = `${baseUrlClient}/users/by-orgId`;

// Procedures
export const GET_ALL_CREATED_PROCEDURE = `${baseUrlProcedure}/get`;
export const GET_ALL_PROCEDURE_LIST = `${baseUrlQualityManual}/get-procedure-list`;

// Notifications
export const SEND_NOTIFICATIONS_TO_ALL = `${baseUrlNotification}/send-to-all`;
